import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { CreateProviderBody } from "@/core/types";

import { createProvider } from "../queryFunctions/createProvider";

export function useCreateProvider({
  ...options
}: UseMutationOptions<void, unknown, CreateProviderBody> = {}) {
  return useMutation({
    mutationFn: createProvider,
    ...options,
  });
}
